import React from 'react'
import { IconDefinition } from '@fortawesome/pro-light-svg-icons'

import { FaIcon } from '../FaIcon/FaIcon'
import { useAppSelector } from '../../../store/hooks'
import { shadeColor } from '../../Util/shadeColor'
import {
  IconListContainer,
  IconListIconCircle,
  IconListTitle,
  IconListLine,
  IconListWrapper,
} from './listStyle'

type Props = {
  title: string
  icon: IconDefinition
  href: string
}

const linkStyle = {
  appearance: 'none' as const,
  background: 'transparent',
  border: 'none',
  padding: 0,
  margin: 0,
  cursor: 'pointer',
  width: '100%',
  textAlign: 'left' as const,
  textDecoration: 'none' as const,
  color: 'inherit',
  display: 'block' as const,
}

export const IconListCard = ({ title, icon, href }: Props) => {
  const settings = useAppSelector((state) => state.settings.values)

  return (
    <IconListWrapper>
      <a href={href} style={linkStyle}>
        <IconListContainer>
          <IconListIconCircle highlightcolor={settings.highlightColor}>
            <FaIcon size="lg" icon={icon} color={settings.highlightColor} />
          </IconListIconCircle>
          <IconListTitle fontcolor={settings.fontColor}>
            {title}
          </IconListTitle>
        </IconListContainer>
      </a>
      <IconListLine lineColor={shadeColor(settings.backgroundColor, -3)} />
    </IconListWrapper>
  )
}
